import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileArrowRightOut: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-arrow-right-out, document-arrow-right-out, outgoing"><path d="M19.25 12.25V9.25L12.75 2.75H4.75V21.25H9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 3.25439V9.24982H18.7501" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M12.75 19H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17.25 16L20.25 19L17.25 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFileArrowRightOut;
